import { Guid } from "@/Common/Models/Guid";
import { LocalEvent } from "../../Actions/LocalEvent";
import { ServerEvent } from "../../Actions/ServerEvent";
import { BaseStore } from "../../BaseStore";
import { BaseOperationHandler } from "../Local/BaseOperationHandler";
import { BaseServerOperationHandler } from "./BaseServerOperationHandler";

class RequestMapper {
    private collection: BaseOperationHandler[];

    constructor() {
        this.collection = [];
    }

    public AddInstance(instance: BaseOperationHandler): void {
        this.collection.push(instance);
    }

    public Map(request: LocalEvent, store: BaseStore, id?: Guid): void {
        this.collection.forEach((instance: BaseOperationHandler) => {
            instance.Invoke(instance, store, request, id);
        });
    }
}

class GlobalRequestMapper {
    private collection: BaseOperationHandler[];
    constructor() { this.collection = []; }
    public AddInstance(instance: BaseOperationHandler): void { this.collection.push(instance); }

    public Map(request: LocalEvent): void {
        this.collection.forEach(instance => instance.GlobalInvoke(instance, request));
    }
}
class ServerResponseMapper {
    private collection: BaseServerOperationHandler[];

    constructor() {
        this.collection = [];
    }

    public AddInstance(instance: BaseServerOperationHandler): void {
        this.collection.push(instance);
    }

    public Map(request: ServerEvent, context: BaseStore): void {
        this.collection.forEach((instance: BaseServerOperationHandler) => {
            instance.Invoke(instance, context, request);
        });
    }
}

export { GlobalRequestMapper, RequestMapper, ServerResponseMapper };
